module.exports = __webpack_public_path__ + "static/media/mia-terms-conditions-en.d2bd3069.pdf";